var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title: _vm.id === null ? "Cadastrar Usuário" : "Editar Usuário",
      },
    },
    [
      _c(
        "vs-tabs",
        { attrs: { color: _vm.colorx } },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Usuário" } },
            [
              _c(
                "validation-observer",
                { ref: "formobserver" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.create.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "vx-row" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Nome",
                                  "label-for": "userName",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: { name: "Nome", rules: "required" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            staticClass: "required",
                                            attrs: {
                                              id: "userName",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              name: "userName",
                                            },
                                            model: {
                                              value: _vm.userName,
                                              callback: function ($$v) {
                                                _vm.userName = $$v
                                              },
                                              expression: "userName",
                                            },
                                          }),
                                          _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "vx-row" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "E-mail",
                                  "label-for": "surname",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "E-mail",
                                    rules: "required|email",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            staticClass: "required",
                                            attrs: {
                                              id: "email",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              name: "email",
                                            },
                                            model: {
                                              value: _vm.userEmail,
                                              callback: function ($$v) {
                                                _vm.userEmail = $$v
                                              },
                                              expression: "userEmail",
                                            },
                                          }),
                                          _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "vx-row mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                staticClass: "mt-5 float-right",
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.cancel },
                              },
                              [_vm._v(" Voltar ")]
                            ),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                staticClass: "mt-5 mr-2 float-right",
                                attrs: {
                                  variant: "primary",
                                  disabled: !_vm.validateForm,
                                  type: "submit",
                                },
                              },
                              [_vm._v(" Salvar ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.id !== null
            ? _c("vs-tab", { attrs: { label: "Grupos" } }, [
                _c(
                  "div",
                  {
                    staticClass: "vx-row mb-6",
                    staticStyle: { "padding-top": "30px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex justify-end" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                staticClass: "mr-2",
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    _vm.showModal = true
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "PlusIcon" },
                                }),
                                _c("span", { staticClass: "align-middle" }, [
                                  _vm._v(_vm._s(_vm.$t("add"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "b-button",
                              {
                                staticClass: "float-right",
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.cancel },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "CornerUpLeftIcon" },
                                }),
                                _c("span", { staticClass: "align-middle" }, [
                                  _vm._v(_vm._s(_vm.$t("back"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("vs-divider"),
                        _c("Grid", {
                          ref: "grid",
                          attrs: {
                            service: _vm.roleService,
                            route_name: "roles",
                            route_grid_path: _vm.userRolesPath,
                            route_delete_path: _vm.userRolesPath,
                            hide_edit: "true",
                            delegate: {
                              destroy: function () {
                                return _vm.destroyRoleUser
                              },
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: "Grupos", active: _vm.showModal },
          on: {
            "update:active": function ($event) {
              _vm.showModal = $event
            },
          },
        },
        [
          _vm.showModal
            ? _c("Grid", {
                attrs: {
                  service: _vm.roleService,
                  delegate: {
                    itemSelected: function () {
                      return _vm.itemSelected
                    },
                  },
                  route_name: "/roles",
                  hide_actions: "true",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }